module.exports = __webpack_public_path__ + "assets/img/404.3d9f90dd.png";